<template>
  <div class="test-container">
    <!-- <Oss v-if="!url" @fileChange="selectedImg" @uploadSucess="coverPicSuccess" browse_button="uploadBtn"
      :actionFile="coverFile" container="coverContainer" :params='coverParams'
      >
      <div id="coverContainer">
        <div id="uploadBtn">
          <img src="~@/assets/img/upload-bg.png" class="upload-btn" />
        </div>
      </div>
    </Oss> -->
    <template v-if="!url">
      <Oss v-if="isClip" @fileChange="selectedImg" @uploadSucess="coverPicSuccess" browse_button="uploadBtn"
        :actionFile="coverFile" container="coverContainer" :params='coverParams' :isClip="isClip"
        >
        <div id="coverContainer">
          <div id="uploadBtn">
            <img src="~@/assets/img/upload-bg.png" class="upload-btn" />
          </div>
        </div>
      </Oss>
      <Oss v-else @uploadSucess="coverPicSuccess" browse_button="uploadBtn" @fileChange="selectedImg"
            :actionFile="coverFile" container="coverContainer" :params='coverParams'>
        <div id="coverContainer">
          <div id="uploadBtn">
            <img src="~@/assets/img/upload-bg.png" class="upload-btn" />
          </div>
        </div>
      </Oss>
    </template>

    <img v-else :src="url" alt="" style="width: 50%;"/>

    <p>err: {{err}}</p>

    <!-- <p>coverFile: {{coverFile}}</p> -->
    <p v-for="i in fileArr" :key="i">{{i}}</p>

    <p>picId: {{picId}}</p>
    
    <Clip v-model="isShowClip" :img="tempImg" @clipComplete="clipComplete" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Oss from '@/components/common/oss'
import Clip from '@/components/common/clip'
import { UPLOAD_TYPE } from '@/config/constant'

export default {
  name: 'cropper',
  components: {
    Oss,
    Clip
  },
  data () {
    return {
      coverFile: null, // 裁切后的file对象
      tempImg: '',
      isClip: true,
      isShowClip: false,
      coverParams: { type: UPLOAD_TYPE.cover },
      err: '',
      url: '',
      fileArr: [],
      picId: ''
    }
  },
  methods: {
    selectedImg (e) {
      try {
        this.tempImg = e.file

        if (this.isClip) {
          this.isShowClip = true
        } else {
          this.coverFile = e.file
          this.fileArr = []
          for (let i in e.file) {
            this.fileArr.push(`${i}: ${e.file[i]}`)
          }
        }
      } catch (err) {
        this.err = err
      }
    },
    clipComplete ({ data, file }) {
      this.coverFile = data
      this.isShowClip = false
      this.fileArr = []
      for (let i in file) {
        this.fileArr.push(`${i}: ${file[i]}`)
      }
    },
    errorMessage (err) {
      this.err = JSON.stringify(err)
    },
    coverPicSuccess ({ picId, url }) {
      this.picId = picId
      this.url = url
      // this.coverFile = null
    },
  }
}
</script>

<style lang="scss">
  .test-container {
    height: 80vh;
    .result {
      width: 100%;
    }
    .vue-cropper {
      background: #fff;
    }
  }
</style>
